import Loadable from "react-loadable";
import { EmptyComponent } from "../../common/EmptyComponent.js";

export const OddsSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/odds" */
      "./OddsSettings.js"
    ),
  loading: EmptyComponent
});

export const AppearanceSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/appearance" */
      "./AppearanceSettings.js"
    ),
  loading: EmptyComponent
});

export const LocalizationSettingsLoaderChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/localization" */
      "./LocalizationSettingsLoader.js"
    ),
  loading: EmptyComponent
});

export const LanguageSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/language" */
      "./LanguageSettings.js"
    ),
  loading: EmptyComponent
});

export const CountrySettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/country" */
      "./CountrySettings.js"
    ),
  loading: EmptyComponent
});

export const BiometricsSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/biometrics" */
      "./BiometricsSettings.js"
    ),
  loading: EmptyComponent
});

export const NotificationsSettingsChunk = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "settings/notifications" */
      "./NotificationsSettings.js"
    ),
  loading: EmptyComponent
});
